<template lang="pug">
div(class="flex justify-center items-center overflow-hidden")
    div(class="spinner-border w-12 h-12 border-4 rounded-full animate-spin")
    div(
        class="ml-5 text-3xl font-bold"
        :class="isDark ? 'text-dark' : 'text-white'"
    ) {{ text }}
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        isDark: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="stylus" scoped>
.spinner-border
    border-color theme('colors.gray.light')
    border-bottom-color theme('colors.gray.darker')
</style>
